// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"280fa37e","453":"90a1eee1","455":"c42f3ae5"}[chunkId] + ".chunk.js";
};